import type { FC } from "react";

import classNames from "classnames";

import type { ContactInfoBlockProps } from "./components";
import { ContactInfoBlock } from "./components";

import styles from "./ContactBlock.module.scss";

export type ContactInfoBlockKeys = "Account" | "Mail" | "Phone" | "Product" | "Info" | "Live Chat";

export type ContactBlockProps = {
  contactBlocks: ContactInfoBlockProps[];
  layout?: "horizontal" | "vertical" | "default";
};

export const ContactBlock: FC<ContactBlockProps> = ({ contactBlocks, layout = "horizontal" }) => {
  return (
    <div className={classNames(styles.contactBlockWrapper, styles[layout])}>
      {contactBlocks.map((contactUsDetail) => (
        <ContactInfoBlock {...contactUsDetail} key={contactUsDetail.ctaLink} />
      ))}
    </div>
  );
};
